// BulletListStyle.js
import BulletList from '@tiptap/extension-bullet-list'

export const BulletListStyle = BulletList.extend({
  name: 'bulletList',

  addAttributes () {
    return {
      ...this.parent?.(),
      listStyleImage: {
        default: null,
        parseHTML: element => element.style.listStyleImage?.replace(/^url\(["']?|["']?\)$/g, '') || null,
        renderHTML: attrs => {
          if (!attrs.listStyleImage) return {}
          return {
            style: `list-style-image: url("${attrs.listStyleImage}"); list-style-position: outside;`
          }
        }
      },

      // optional extras if you want:
      listStyleType: {
        default: null,
        parseHTML: element => element.style.listStyleType || null,
        renderHTML: attrs => (attrs.listStyleType ? { style: `list-style-type: ${attrs.listStyleType};` } : {})
      }
    }
  },

  addCommands () {
    return {
      ...this.parent?.(),

      setBulletListIcon:
        (url) =>
          ({ chain }) => {
            if (!url) return false
            return chain()
              .focus()
              .updateAttributes('bulletList', { listStyleImage: url })
              .run()
          },

      unsetBulletListIcon:
        () =>
          ({ chain }) => {
            return chain()
              .focus()
              .updateAttributes('bulletList', { listStyleImage: null })
              .run()
          }
    }
  }
})